/**
 * Shown after the inactivity lock (SEC-014). It carries no record data, no name and no navigation: only the
 * brand, the reason and the way back. Unlocking is a fresh sign-in at the identity provider; this application
 * has no password field and no way to resume the old session.
 */
import { useState } from "react";
import logoWhite from "../assets/corpex-logo.png";
import { beginSignIn } from "../lib/auth.js";

export function LockScreen() {
  const [problem, setProblem] = useState<string | null>(null);
  const unlock = () => {
    setProblem(null);
    beginSignIn().catch((e: unknown) =>
      setProblem(e instanceof Error ? e.message : "The identity provider could not be reached."),
    );
  };
  return (
    <main className="signin-ground">
      <div className="signin-card">
        <aside className="signin-stage">
          <img src={logoWhite} alt="Corpex" width={176} height={55} className="signin-logo" />
          <div className="signin-welcome">
            <p className="signin-headline">Session locked</p>
            <p className="signin-tagline">Electronic batch records</p>
          </div>
        </aside>
        <section className="signin-panel" aria-labelledby="lock-title">
          <h1 id="lock-title" className="signin-title">
            Locked
          </h1>
          <p className="signin-copy">
            This screen was locked after a period without activity. Sign in again to continue. Nothing is
            shown until you do.
          </p>
          {problem ? (
            <p role="alert" className="signin-problem">
              {problem}
            </p>
          ) : null}
          <button type="button" onClick={unlock} className="signin-button">
            Sign in again
          </button>
        </section>
      </div>
    </main>
  );
}
